import {
  Box,
  makeStyles,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useField } from "react-final-form";
import { useDataProvider } from "react-admin";
import { useEffect, useState } from "react";
import { FormHelperText } from "@material-ui/core";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  selected: { backgroundColor: theme.orange + "!important" },
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    marginTop: 15,
    marginBottom: 15,
    marginRight: 70,
  },
  menuCategoryPaper: {
    borderRadius: 12,
  },
  menuPaper: {
    borderRadius: 12,
    marginTop:50
  },
  textStyle: { fontSize: 16 },
}));
const CatandSubCatInput = ({ required }) => {
  const dataProvider = useDataProvider();
  const [categories, setCategories] = useState();
  const [subCategories, setSubCategories] = useState();
  const [displaySubCategories, setDisplaySubCategories] = useState([]);
  const [, setShowDefaultSubCat] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const translate = useTranslate();
  const {
    input: { onChange: onCatChange },
    meta: { error: errorCatId, touched: touchedCatId },
  } = useField("category_id");
  const {
    input: { onChange: onSubCatChange },
  } = useField("sub_category_id");
  const {
    input: { value: defCat },
  } = useField("category");
  const {
    input: { value: defSubCat },
  } = useField("sub_category");
  useEffect(() => {
    async function fetchAll() {
      try {
        const categories = await dataProvider.getList("product-categories", {
          filter: { status: "Active" },
        });
        const subCategories = await dataProvider.getList(
          "product-sub-categories",
          { filter: { status: "Active" } }
        );
        setSubCategories(subCategories.data);
        setCategories(categories.data);
        onCatChange(defCat.id);
        onSubCatChange(defSubCat.id);

        if (defSubCat) setShowDefaultSubCat(true);
        return setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subCategories)
      setDisplaySubCategories(
        subCategories?.filter((sub) => sub.category.id === defCat.id)
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);
  const classes = useStyles();

  if (loading) return null;
  if (error) return null;

  const handleCategorySelect = (e) => {
    onCatChange(e.target.value);
    setDisplaySubCategories(
      subCategories.filter((sub) => sub.category.id === e.target.value)
    );
    onSubCatChange(null);
    setShowDefaultSubCat(false);
  };
  const handleSubCategorySelect = (e) => {
    onSubCatChange(e.target.value);
  };
  return (
    <Box className={classes.container}>
      <Box style={{ display: "flex" }}>
        <Typography className={classes.textStyle}>Category</Typography>

        {required ? (
          <Typography className={classes.textStyle} style={{ color: "orange" }}>
            *
          </Typography>
        ) : null}
      </Box>
      <Box style={{ width: "100%"}}>
        <Select
          style={{ width: 300  }}
          defaultValue={defCat.id}
          onChange={handleCategorySelect}
          MenuProps={{
            classes: {
              paper: classes.menuCategoryPaper,
            },
          }}
        >
          {categories.map((cat) => {
            return <MenuItem value={cat.id}>{cat.name}</MenuItem>;
          })}
        </Select>
        {touchedCatId && errorCatId ? (
          <FormHelperText style={{ color: "red" }}>{errorCatId}</FormHelperText>
        ) : null}
      </Box>
      <Typography className={classes.textStyle} style={{ marginTop: 15 }}>
        Sub-Category
      </Typography>
      <Select
        style={{ width: 300 }}
        defaultValue={defSubCat.id}
        onChange={handleSubCategorySelect}
        MenuProps={{
          classes: {
            paper: classes.menuPaper,
          },
          
        }}
      >
        {displaySubCategories.length > 0 ? (
          displaySubCategories.map((scat) => {
            return <MenuItem value={scat.id}>{scat.name}</MenuItem>;
          })
        ) : (
          <MenuItem value="" >
            <Typography>
              {translate("ra.text.paymentMethod.noOption")}
            </Typography>
          </MenuItem>
        )}
      </Select>
    </Box>
  );
};

export default CatandSubCatInput;
